export function logIn(data) {
  return window.axios
    .post("/hub/v1/account/login", data)
    .then((response) => response.data);
}

export function refreshToken({ accessToken, refreshToken }) {
  return window.axios
    .post("/hub/v1/account/refresh-token", { accessToken, refreshToken })
    .then((response) => response.data)
    .catch(() => null);
}

export function logOut() {
  return window.axios.post("/hub/v1/account/logout");
}

export function changeMyPassword({
  oldPassword,
  password,
  passwordConfirmation,
}) {
  return window.axios
    .put(`/hub/v1/account/change-password`, {
      oldPassword,
      password,
      passwordConfirmation,
    })
    .then((response) => response.data);
}
